import { render } from "./StepsCard.vue?vue&type=template&id=18d4d14a"
import script from "./StepsCard.vue?vue&type=script&lang=js"
export * from "./StepsCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__